<template>
  <div>
    <div
      v-if="type === 'normal'"
      :class="['video-card-normal', fluid && 'video-card-normal-fluid']"
      v-ripple
    >
      <router-link v-if="img" :to="to">
        <div class="video-card-icon">
          <img
            :src="img"
            :alt="title"
            :title="title"
            loading="lazy"
            @error="invalidImage = true"
          />
        </div>
      </router-link>
      <div class="text-body-2 font-weight-bold video-card-normal-title mt-2">
        <router-link
          :to="to"
          v-html="title"
          class="text-decoration-none grey--text text--darken-4"
        ></router-link>
      </div>
    </div>
    <div v-else-if="type === 'large'" class="video-card-large">
      <router-link v-if="img" :to="to">
        <div class="video-card-icon">
          <img
            :src="img"
            :alt="title"
            :title="title"
            loading="lazy"
            @error="invalidImage = true"
          />
        </div>
      </router-link>
      <div class="text-h6 font-weight-bold video-card-large-title mt-0">
        <router-link
          :to="to"
          v-html="title"
          class="text-decoration-none grey--text text--darken-4"
        ></router-link>
      </div>
    </div>
    <v-card
      v-else-if="type === 'x-large'"
      :to="to"
      :style="{ '--img': `url('${img}')` }"
      class="video-card-xlarge video-card-icon"
      flat
      tile
    >
      <div class="video-card-xlarge-inner d-flex flex-column justify-end">
        <div>
          <div
            v-html="title"
            class="video-card-xlarge-title font-weight-bold white--text mb-1"
          ></div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { formatToURL, getYoutubeCode } from "@/components/utils.js";

const optionsType = ["normal", "large", "x-large"];

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    fluid: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "normal",
      validator: (v) => optionsType.includes(v),
    },
  },
  computed: {
    to() {
      return `/videos/${formatToURL(this.title)}-${this.id}`;
    },
    img() {
      const youtubeCode = getYoutubeCode(this.link);

      return `https://img.youtube.com/vi/${youtubeCode}/hqdefault.jpg`;
    },
  },
};
</script>

<style>
.video-card-icon {
  position: relative;
}

.video-card-icon::before {
  background-image: url(/img/play.svg);
  background-repeat: no-repeat;
  background-size: contain;
  background-color: transparent;
  content: "";
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  opacity: 0.7;
  position: absolute;
  top: 50%;
  transition: all 0.1s linear;
  width: 50px;
  z-index: 90;
}

/* VIDEO-CARD TYPE NORMAL */
.video-card-normal {
  position: relative;
  max-width: 270px;
}

.video-card-normal-fluid {
  max-width: initial;
}

.video-card-normal:hover .video-card-normal-img::before {
  opacity: 0.9;
}

.video-card-normal img {
  aspect-ratio: 16 / 9;
  display: block;
  object-fit: cover;
  width: 100%;
}

.video-card-normal img,
.video-card-normal-title,
.video-card-normal-category {
  transition: all 0.1s linear;
}

@media screen and (max-width: 1264px) {
  .video-card-normal-title {
    font-size: 14px;
  }
}

.video-card-normal:hover img {
  opacity: 0.8;
}

.video-card-normal:hover .video-card-normal-title a {
  color: var(--v-primary-darken2) !important;
}

/* VIDEO-CARD TYPE LARGE */
.video-card-large {
  display: grid;
  grid-template-columns: 270px auto;
  gap: 12px;
}

.video-card-large img {
  aspect-ratio: 16 / 9;
  display: block;
  object-fit: cover;
  width: 100%;
}

.video-card-large:hover img {
  opacity: 0.8;
}

.video-card-large:hover .video-card-large-title a {
  color: var(--v-primary-darken2) !important;
}

/* VIDEO-CARD TYPE X-LARGE */
.video-card-xlarge {
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0) 75.22%
    ),
    var(--img), #b7b7b7;

  aspect-ratio: 67/40;
  background-size: cover;
  background-position: center;
}
.video-card-xlarge-inner {
  padding: 0 16px 16px;
  height: 100%;
  width: 100%;
}
.video-card-xlarge-title {
  font-size: 28px;
  line-height: 28.8px;
}
@media screen and (max-width: 960px) {
  .video-card-xlarge-title {
    font-size: 16px;
    line-height: 19px;
  }
  .video-card-xlarge-inner {
    padding: 16px 12px;
  }
}

@media screen and (max-width: 600px) {
  .video-card-xlarge {
    max-width: calc(100vw - 24px) !important;
  }
}

.video-card-xlarge,
.video-card-xlarge .video-card-xlarge-title {
  transition: all 0.1s linear;
}

.video-card-xlarge:hover {
  opacity: 0.9;
}

.video-card-xlarge:hover .video-card-xlarge-title {
  color: #dbdbdb !important;
}
</style>
